<template>
  <UCard :ui="{ rounded: 'rounded-none md:rounded-lg' }">
    <div class="space-y-6">
      <!-- Varyant Seçimi -->
      <div class="space-y-4">
        <!-- Tek Terim Olan Özellikler -->
        <div v-if="hasSingleTermAttributes" class="mb-3">
          <div class="grid grid-cols-2 gap-2 sm:grid-cols-3 md:grid-cols-4">
            <div v-for="(attributes, attrName) in singleTermAttributes" :key="attrName">
              <FrontendProductBuyBoxVariantAttributeInfo :attribute-name="attrName" :term="attributes[0]" />
            </div>
          </div>
        </div>

        <!-- Çoklu Terim Seçimleri -->
        <div v-for="(attributes, attrName) in multipleTermAttributes" :key="attrName">
          <!-- Renk varyantı için özel komponent -->
          <FrontendProductBuyBoxVariantAttributeColor v-if="attrName.toLowerCase() === 'renk'" :product-id="productId"
            :attribute-name="attrName" :terms="attributes" />
          <!-- Diğer varyantlar için temel komponent -->
          <FrontendProductBuyBoxVariantAttributeBase v-else :attribute-name="attrName" :terms="attributes" />
        </div>

        <!-- Bilgilendirme Mesajı -->
      </div>

      <!-- Seçili Varyant Bilgileri -->
      <template v-if="variationStore.selectedVariation">
        <div class="space-y-4">
          <!-- Fiyat Bilgileri -->
          <FrontendProductBuyBoxPriceInfo :original-price="variationStore.originalPrice"
            :discounted-price="variationStore.salePrice" />

          <!-- Stok Durumu -->
          <FrontendProductBuyBoxStockInfo :stock-status="variationStore.isInStock"
            :stock-qty="variationStore.stockQty" />

          <!-- Satıcı Bilgileri -->
          <FrontendProductBuyBoxVendorInfo :vendor="variationStore.vendorInfo" />

          <!-- Sepete Ekle -->
          <FrontendProductBuyBoxAddToCartVariant :product-id="productId" />
        </div>
      </template>
    </div>
  </UCard>
</template>

<script setup>
// Props tanımlaması
const props = defineProps({
  variations: {
    type: Array,
    required: true
  },
  productId: {
    type: Number,
    required: true
  }
})

const variationStore = useBuyboxVariationsStore()

// Tek terim ve çoklu terim bilgilerini ayırma
const singleTermAttributes = computed(() => {
  const result = {}
  Object.entries(variationStore.getGroupedAttributes).forEach(([attrName, terms]) => {
    if (terms.length === 1) {
      result[attrName] = terms
      // Otomatik olarak seç
      if (variationStore.selectedTerms[attrName] !== terms[0].name) {
        variationStore.selectTerm(attrName, terms[0].name)
      }
    }
  })
  return result
})

const multipleTermAttributes = computed(() => {
  const result = {}
  Object.entries(variationStore.getGroupedAttributes).forEach(([attrName, terms]) => {
    if (terms.length > 1) {
      result[attrName] = terms
    }
  })
  return result
})

const hasSingleTermAttributes = computed(() => {
  return Object.keys(singleTermAttributes.value).length > 0
})

// Varyasyonlar değiştiğinde store'u güncelle
watch(
  () => props.variations,
  (newVariations) => {
    variationStore.resetState()
    variationStore.setVariations(newVariations)
    variationStore.initializeVariation()
  },
  { immediate: true, deep: true }
)

// Komponent unmount olduğunda state'i temizle
onUnmounted(() => {
  variationStore.resetState()
})
</script>

<style scoped>
.animate-shake {
  animation: shake 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}

@keyframes shake {

  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-2px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(2px, 0, 0);
  }
}
</style>
